module.exports = __webpack_public_path__ + "img/fileicon.19689ef7.svg";